import React from 'react';
import { getReviewId } from 'query/review';
import { Button } from 'components/core';

type StartDiscussionsButtonProps = {
  selectedStudyIds: number[];
};

export const StartDiscussionsButton = ({
  selectedStudyIds,
}: StartDiscussionsButtonProps) => {
  const reviewId = getReviewId();
  const isDisabled = selectedStudyIds.length < 1;
  const url = `/reviews/${reviewId}/comments/new?study_ids=${selectedStudyIds.join(
    ','
  )}`;

  return (
    <Button
      to={url}
      type={isDisabled ? 'neutral' : 'brand'}
      disabled={isDisabled}
      data-pendo-key="start-discussion"
    >
      Start discussion
    </Button>
  );
};
